import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button } from 'react-bootstrap';
import { IoEye } from 'react-icons/io5';
import { RiSendPlaneFill } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeDark,
    colorSchemeLightCold,
    DateFilterModule,
    themeQuartz
} from 'ag-grid-community';
import { ThemeContext } from '../../../../../auth';
import { useMediaQuery } from 'react-responsive';

function TabsPcpSewaDark({
    listPcpSewa,
}) {

    const isMobile = useMediaQuery({ maxWidth: 736 });

    const { theme } = useContext(ThemeContext);

    const navigate = useNavigate();

    const location = useLocation();

    const pcpApprove = (row) => {
        navigate(`/pcp-approve/${row.id}`, { state: { data: row } })
    };

    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        const dataTableFilter = listPcpSewa.map(({ ...rest }) => rest);

        setDataTable(
            dataTableFilter.map((data) => {
                return {
                    ...data,
                    no_lead: data?.lead?.noLead,
                    customerName: data?.lead?.customer?.title?.titleName === "Others"
                        ? data?.lead?.customer?.name
                        : `${data?.lead?.customer?.title?.titleName}. ${data?.lead?.customer?.name}`,
                    progressLead: data?.lead.status + '%',
                    salesName: data?.firstName.toUpperCase() + ' ' + data?.lastName.toUpperCase(),
                    leadDate: data?.lead?.date
                };
            })
        );
    }, [listPcpSewa]);

    ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
    const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (dataTable && dataTable.length > 0) {
            setRowData(dataTable);
        }
    }, [dataTable]);

    const filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (!cellValue) return -1;

            const dateParts = cellValue.split("-");
            const cellDate = new Date(
                Number(dateParts[0]),
                Number(dateParts[1]) - 1,
                Number(dateParts[2])
            );

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
        minValidYear: 2000,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
    };


    const colDefs = [
        {
            field: "no_lead",
            headerName: "No. Lead",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.no_lead}
                    </div>
                );
            },
        },
        {
            field: "leadDate",
            headerName: "Tanggal",
            filter: "agDateColumnFilter",
            sort: 'asc',
            filterParams: filterParams,
        },
        {
            field: "salesName",
            headerName: "Sales",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.salesName}
                    </div>
                );
            },
        },
        {
            field: "customerName",
            headerName: "Customer",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.customerName}
                    </div>
                );
            },
        },
        {
            field: "progressLead",
            headerName: "Progress Lead",
            sortable: true,
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.progressLead}
                    </div>
                );
            },
        },
        {
            field: location.pathname == '/pcp' ? 'proses' : 'detail',
            headerName: location.pathname == '/pcp' ? 'Proses' : 'Detail',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => pcpApprove(row.data)}
                    >
                        <Button
                            variant='btn'
                            onClick={() => pcpApprove(row.data)}
                        >
                            {location.pathname == '/pcp' ?
                                (
                                    <>
                                        &nbsp;<RiSendPlaneFill size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                                    </>
                                )
                                :
                                (
                                    <>
                                        &nbsp;<IoEye size={20} color={theme == 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                                    </>
                                )
                            }

                        </Button>
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div style={{ height: tableHeight }}>
            <AgGridReact
                theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={isMobile ? false : true}
                rowHeight={30}
            />
        </div>
    )
}

export default TabsPcpSewaDark
